import { ActivatedRouteSnapshot, CanActivateFn, Router, RouterStateSnapshot } from '@angular/router';
import { inject } from '@angular/core';
import { AuthenticationService } from '@lib-common/services/authentication.service';

export const AppAuthGuard: CanActivateFn = (route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => {
  const authService = inject(AuthenticationService);
  const router = inject(Router);
  const user = authService.getCurrentUser;
  const hasMinAccess = route?.data?.['authenticated'] ? Boolean(user) : true;
  const userBlacklisted = route?.data?.['userBlackListed'];
  if (!hasMinAccess) {
    // Zitadel branch: redirect to Zitadel login (initCodeFlow) instead of internal route.
    // Capture the intended URL (path+query+fragment) into the OIDC state so the
    // callback can deep-link the user back to it instead of dumping them at '/' (FR-LOGIN5).
    if (authService.isZitadelEnabled()) {
      authService.loginWithZitadel({ returnUrl: state.url });
      return false;
    }
    router.navigate(['/authentication/login']).then();
  }
  if (user && userBlacklisted) {
    router.navigate(['/']).then();
  }
  return hasMinAccess;
};
